<template>
    <div class="container orderList">
        <van-nav-bar
            title="订单明细"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"/>
        <div class="container">
            <div class="header">
                <div class="selele-date df">
                    <van-dropdown-menu active-color="#1989fa">
                        <van-dropdown-item class="dropdown" v-model="operatorValue" @change="onOperatorNameChange"
                                           :options="operatorOptions"/>
                    </van-dropdown-menu>
                </div>
                <div class="date">
                    <div @click="showSelectStartDate = true">开始时间: {{ startDate | formatTime }} ></div>
                    <div @click="showSelectEndDate = true">结束时间: {{ endDate | formatTime }} ></div>
                </div>
                <div class="order-total">
                    <div class="df jcsb">
                        <span>订单总数: {{ order.order_count }}笔</span>
                        <span>订单总金额: {{ order.order_total }}元</span>
                    </div>
<!--                    <div div class="df jcsb">-->
<!--                        <span>加班订单数: {{ order.overtime_order_count }}笔</span>-->
<!--                        <span>加班订单金额: {{ order.overtime_order_total }}元</span>-->
<!--                    </div>-->
                    <div div class="df jcsb">
                        <span>微信订单数: {{ order.wxpay_order_count }}笔</span>
                        <span>支付宝订单数: {{ order.alipay_order_count }}笔</span>
                    </div>
                </div>
            </div>
            <div class="order-list">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="宝宝也是有底线的"
                    loading-text="数据加载中"
                    @load="onReachBottom">
                    <span></span>
                    <div class="order-box df" v-for="item in order_list">
                        <div class="order-title">
                            <img class="ico" src="@/assets/wxpay.png"/>
                            <div class="pdl10">
                                <div>车牌号:{{ item.bus.bus_number_plate }} 司机:
                                    {{ item.duty ? item.duty.name : "暂无" }}({{ item.payment == 2 ? "微信" : "支付宝" }})
                                </div>
<!--                                <div v-if="item.overtime" class="fs12 pdt5 overtime">-->
<!--                                    {{ item.pay_time * 1000 | formatTime}}(加班)-->
<!--                                </div>-->
                                <div  class="fs12 pdt5">
                                    {{ item.pay_time * 1000 | formatTime }}
                                </div>
                            </div>
                        </div>
                        <div class="order-amount">
                            +{{ item.amount }}
                        </div>
                    </div>
                </van-list>
            </div>
            <van-popup v-model="showSelectStartDate" @close="onClose" position="bottom">
                <van-datetime-picker type="datetime"
                                     @cancel="onClose" @close="onClose" data-type="start" @confirm="confirm"
                                     :min-date="minDate" :max-date="maxDate"/>
            </van-popup>
            <van-popup v-model="showSelectEndDate" @close="onClose" position="bottom">
                <van-datetime-picker type="datetime"
                                     @cancel="onClose" @close="onClose" data-type="end" @confirm="confirm"
                                     :min-date="minDate" :max-date="maxDate"/>
            </van-popup>
        </div>
<!--        <van-overlay style=" padding-top: 100px;" class="loading-container" :show="loading" @click="loading = false">-->
<!--            <van-loading size="36px" vertical>加载中...</van-loading>-->

<!--        </van-overlay>-->
    </div>
</template>

<script>
var formatNumber = function (n) {
    n = n.toString()
    return n[1] ? n : "0" + n
}
export default {
    name: "orderList",
    data() {
        return {
            loading: false,
            show: false,
            minDate: new Date(2022, 0, 1),
            maxDate: new Date(),
            operatorOptions: [{
                text: '全部车辆',
                value: -1
            }],
            operatorValue: -1,
            startDate: new Date(new Date().toLocaleDateString()).getTime(),
            endDate: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            selectType: 1,
            page: 1,
            showSelectStartDate: false,
            showSelectEndDate: false,
            order: {},
            order_list: [],
            finished: false,
        }
    },
    mounted() {
        this.refresh();
        this.getoperatorName();
    },
    filters: {
        formatTime(time) {
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()

            var hour = date.getHours()
            var minute = date.getMinutes()
            var second = date.getSeconds()

            return [year, month, day].map(formatNumber).join('/') + " " + [hour, minute, second].map(formatNumber).join(":");
        },
        formatDate(time) {
            var date = new Date(time);
            var year = date.getFullYear()
            var month = date.getMonth() + 1
            var day = date.getDate()


            return [year, month, day].map(formatNumber).join('/');
        },
    },
    methods: {
        onClickLeft(){
            this.$router.back();
        },
        onReachBottom() {
            if (this.finished) {
                return;
            }

            this.page++;
            this.getOrder();
        },
        refresh() {
            this.onClose();
            this.page = 1;
            this.order_list = [];
            this.finished = false;
            this.getOrder();
        },
        confirm(value) {
            if (this.showSelectStartDate) {
                this.startDate = +value;
                this.showSelectStartDate = false;
            } else {
                this.endDate = +value;
                this.showSelectEndDate = false;
            }
            this.finished = false;
            this.getOrder();
        },
        onClose() {
            this.showSelectEndDate = false;
            this.showSelectStartDate = false;
        },
        getOrder() {
            this.loading = true;
            var searchParams = {
                bus_id: this.operatorValue,
                start_date: this.startDate / 1000,
                end_date: parseInt(this.endDate / 1000),
                page: this.page,
                size: 10
            };
            // console.log(searchParams);
            this.$http.get("/order/orderList", {params: searchParams}).then(res => {
                this.order = res.data;
                var order_list = this.order_list;
                console.log(res.data.order_list.length);
                if (!res.data.order_list.length) {
                    this.finished = true;
                } else {
                    order_list = order_list.concat(res.data.order_list);
                }
                this.order_list = order_list;
                this.loading = false;
            });

        },
        getoperatorName() {
            this.$http.get("/buses").then(res => {
                var options = [{
                    text: '全部车辆',
                    value: -1
                }];
                var list = res.data;
                list.forEach(bus => {
                    options.push({text: bus.bus_number_plate, value: bus.id})
                })
                this.operatorOptions = options;
            });
        },
        onOperatorNameChange() {
            this.refresh();
        }
    }
}
</script>

<style scoped>
.container {
    font-size: 14px;
    color: #666;
}

.header {
    color: #666;
    padding: 10px;
    background-color: #5CA3F6;
    color: #fff;
}

.selele-date {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #fff;
    padding: 5px;
}

.date {
    padding-top: 5px;
    padding-left: 10px;
    font-size: 16px;
}

.date div:first-child {
    margin-bottom: 10px;
}


.order-total {
    padding: 0px 10px;
    padding-top: 5px;
}

.order-total div {
    padding: 2px 0px;
    font-size: 16px;
}

.ico {
    width: 40px;
    height: 40px;
}

.order-list {
    background-color: #fff;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
}

.order-box {
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}

.order-title {
    display: flex;
}

.order-title view {
    display: flex;
    flex-direction: column;
}

.order-amount {
    font-size: 18px;
    color: #FF6633;
}

.overtime {
    color: rgb(247, 80, 38);
}
</style>
<style>
.orderList .van-dropdown-menu__bar {
    height: 35px;
    flex: 1;
}

.orderList .van-dropdown-menu__item {
    flex: 1;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/OrderList.vue